<template>
<v-container max-width="100%" style="margin-top: 5%;" fluid>
    <CRUDEmpresas />
</v-container>
</template>

<script>
// @ is an alias to /src
import CRUDEmpresas from '@/components/CRUDEmpresas.vue'

export default {
  name: 'Empresas',
  components: {
    CRUDEmpresas
  }
}
</script>